import React, { useMemo } from 'react';
import { Popover, PopoverOrigin } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    pointerEvents: 'none'
  },
  paper: {
    borderRadius: theme.spacing(2.5),
    pointerEvents: 'auto',
    translate: `${theme.spacing(-5)} ${theme.spacing(-4.25)}`
  }
}));

type TimeSignalQuickActionsPopoverProps = {
  onPopoverOpen: (
    event: React.MouseEvent<HTMLElement> | null,
    overrideElem?: HTMLElement | null
  ) => void;
  onPopoverClose: () => void;
  anchorEl: HTMLElement | null;
  isPopoverOpen: boolean;
  children: React.ReactNode;
};

export const TimeSignalQuickActionsPopover: React.FC<TimeSignalQuickActionsPopoverProps> = ({
  children,
  onPopoverClose,
  onPopoverOpen,
  isPopoverOpen,
  anchorEl
}: TimeSignalQuickActionsPopoverProps) => {
  const classes = useStyles();
  const popoverClasses = useMemo(
    () => ({
      paper: classes.paper
    }),
    [classes.paper]
  );
  const paperProps = useMemo(
    () => ({
      onMouseEnter: () => onPopoverOpen(null, anchorEl),
      onMouseLeave: onPopoverClose
    }),
    [onPopoverClose, onPopoverOpen, anchorEl]
  );
  const anchorOriginProps = useMemo(
    () => ({
      vertical: 'top',
      horizontal: 'right'
    }),
    []
  );
  const transformOriginProps = useMemo(
    () => ({
      vertical: 'top',
      horizontal: 'right'
    }),
    []
  );

  return (
    <Popover
      open={Boolean(isPopoverOpen)}
      onClose={onPopoverClose}
      anchorEl={anchorEl}
      disableRestoreFocus
      className={classes.root}
      classes={popoverClasses}
      PaperProps={paperProps}
      anchorOrigin={anchorOriginProps as PopoverOrigin}
      transformOrigin={transformOriginProps as PopoverOrigin}
      transitionDuration={0}
    >
      {children}
    </Popover>
  );
};
